import { useMemo } from "react";
import { useExploreInteractions } from "@/v2/entities/explore/Explore.api";
import { TicketView } from "@/v2/features/interaction-view/TicketView";
import { ExploreInteractionRow } from "@/v2/entities/explore/Explore.model";
import { Filter } from "@/v2/entities/explore/Explore.filter";
import { useExploreEnrichments } from "@/v2/features/explore/useExploreEnrichments";
import { SimulatorWrapper } from "@/routes/simulators/wrapper";
import { useExploreCustomFields } from "@/v2/features/explore/useExploreCustomFields";

function TrackerItemTicketView({
  ticketId,
  onClose,
}: {
  ticketId: string;
  onClose: () => void;
}) {
  const enrichments = useExploreEnrichments();
  const customFields = useExploreCustomFields();
  // Create a filter to get the specific ticket by ID
  const filter: Filter = useMemo(
    () => ({
      and: [{ id: { eq: ticketId } }],
    }),
    [ticketId]
  );

  // Get ticket data using useExploreTickets
  const {
    data: ticketsData,
    isLoading,
    error,
  } = useExploreInteractions({
    source: "tickets",
    sorting: [],
    filter,
    enabled: true,
  });

  // Extract the ticket from the response
  const ticket = useMemo<ExploreInteractionRow | undefined>(() => {
    if (!ticketsData) {
      return;
    }

    return ticketsData.length > 0 ? ticketsData[0] : undefined;
  }, [ticketsData]);

  if (isLoading || ticket == null || error) {
    return <></>;
  }

  return (
    <SimulatorWrapper>
      <TicketView
        ticket={ticket}
        enrichments={enrichments}
        customFields={customFields}
        onClose={onClose}
        allowSendToTraining={true}
      />
    </SimulatorWrapper>
  );
}

export default TrackerItemTicketView;
